export default __webpack_public_path__ + "static/media/cupImgForHandball.56585bc1.jpg";